import React, { useContext, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import SignupModal from './components/SignupModal';
import LoginModal from './components/LoginModal';
import {
  Box,
  Flex,
  HStack,
  Button,
  Text,
  Link,
  IconButton,
  useDisclosure,
  Collapse,
  VStack,
  Container,
  useColorModeValue
} from '@chakra-ui/react';
import { FaMusic, FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const [showSignup, setShowSignup] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const { isOpen, onToggle } = useDisclosure();

  const textColor = useColorModeValue('white', 'gray.100');

  return (
    <Box
      bg="rgba(10, 10, 31, 0.8)"
      backdropFilter="blur(20px)"
      color={textColor}
      py={4}
      px={4}
      position="sticky"
      top={0}
      zIndex={1000}
      borderBottom="1px solid"
      borderColor="whiteAlpha.200"
      boxShadow="0 4px 30px rgba(0, 0, 0, 0.3)"
    >
      <Container maxW="container.xl">
        <Flex align="center" justify="space-between">
          {/* Logo */}
          <HStack spacing={4} align="center">
            <Box
              p={2}
              borderRadius="lg"
              bgGradient="linear(to-r, #667eea, #764ba2)"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <FaMusic size="24px" color="white" />
            </Box>
            <Link
              as={RouterLink}
              to="/"
              fontSize="2xl"
              fontWeight="bold"
              bgGradient="linear(to-r, #667eea, #764ba2, #f093fb)"
              bgClip="text"
              _hover={{
                textDecoration: 'none',
                transform: 'scale(1.05)',
              }}
              transition="all 0.3s"
            >
              Pyaar.ai
            </Link>
          </HStack>

          {/* Desktop Navigation Links */}
          <HStack spacing={6} display={{ base: 'none', md: 'flex' }}>
            {user ? (
              <>
                <Text fontWeight="medium" color="whiteAlpha.800">
                  Welcome, {user.username}
                </Text>
                <Button
                  variant="outline"
                  size="md"
                  onClick={logout}
                  borderColor="purple.400"
                  color="purple.300"
                  _hover={{
                    bg: 'purple.500',
                    color: 'white',
                    transform: 'translateY(-2px)',
                  }}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="ghost"
                  size="md"
                  onClick={() => setShowLogin(true)}
                  color="whiteAlpha.900"
                  _hover={{
                    bg: 'whiteAlpha.200',
                    transform: 'translateY(-2px)',
                  }}
                >
                  Login
                </Button>
                <Button
                  size="md"
                  onClick={() => setShowSignup(true)}
                  bgGradient="linear(to-r, #667eea, #764ba2)"
                  _hover={{
                    bgGradient: 'linear(to-r, #764ba2, #667eea)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.6)',
                  }}
                >
                  Signup
                </Button>
              </>
            )}
          </HStack>

          {/* Mobile Menu Toggle */}
          <IconButton
            display={{ base: 'flex', md: 'none' }}
            onClick={onToggle}
            icon={isOpen ? <FaTimes /> : <FaBars />}
            variant="ghost"
            aria-label="Toggle Navigation"
            colorScheme="blue"
          />
        </Flex>

        {/* Mobile Menu */}
        <Collapse in={isOpen} animateOpacity>
          <VStack
            mt={4}
            pb={4}
            display={{ md: 'none' }}
            spacing={4}
            align="start"
          >
            {user ? (
              <>
                <Text fontWeight="medium">Welcome, {user.username}</Text>
                <Button 
                  w="full"
                  variant="outline" 
                  onClick={logout}
                  colorScheme="blue"
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button 
                  w="full"
                  variant="ghost" 
                  onClick={() => {
                    setShowLogin(true);
                    onToggle();
                  }}
                  colorScheme="blue"
                >
                  Login
                </Button>
                <Button 
                  w="full"
                  colorScheme="blue" 
                  onClick={() => {
                    setShowSignup(true);
                    onToggle();
                  }}
                >
                  Signup
                </Button>
              </>
            )}
          </VStack>
        </Collapse>
      </Container>
      
      {/* Modals */}
      <SignupModal show={showSignup} onClose={() => setShowSignup(false)} />
      <LoginModal show={showLogin} onClose={() => setShowLogin(false)} />
    </Box>
  );
};

export default Navbar;
